import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@material-ui/core';
import { FlexCol, FlexRow, useBreakpoint, useWindowSize } from '@xyo-network/sdk-xyo-react-js';
const WindowSize = (props) => {
    const size = useWindowSize();
    const breakpoint = useBreakpoint();
    return (_jsx(FlexCol, Object.assign({}, props, { children: _jsx(FlexRow, { children: _jsx(Typography, Object.assign({ variant: "body1" }, { children: `Size: [${size.width}, ${size.height}] ${breakpoint}` }), void 0) }, void 0) }), void 0));
};
export default WindowSize;
